// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"177":"home","270":"list-userTypes-logistic-center","966":"userAssignment"}[chunkId] || chunkId) + ".js";
};